import script from "./ComputeWizardClamping.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComputeWizardClamping.vue?vue&type=script&setup=true&lang=ts"

import "./ComputeWizardClamping.vue?vue&type=style&index=0&id=7579f944&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7579f944"]])

export default __exports__